export const getEnvironmentFromUrl = () => {
  return window.origin.split('://')[1].split('.')[0];
};
